import styled, { css } from 'styled-components';

import { VariantType } from './Typography.types';

// bit of a hack to get line-clamp working avoiding stylelint moaning about it
const lineClamp = ({ maxLines }: { maxLines?: number }) =>
  maxLines &&
  css`
    ${`
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: ${maxLines};
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
    `}
  `;

export const Text = styled.p<{ maxLines?: number; variant: VariantType }>`
  overflow-wrap: break-word;
  margin: 0 0 0.35em;
  ${({ theme, variant }) => theme.getFluidFont(variant)};
  ${({ theme, variant }) =>
    variant in theme.fontSizeWeightMap
      ? `font-weight: ${theme.fontSizeWeightMap[variant as keyof typeof theme.fontSizeWeightMap]};`
      : ''}
  ${({ theme, variant }) =>
    variant in theme.fontSizeLineHeightMap
      ? `line-height: ${theme.fontSizeLineHeightMap[variant as keyof typeof theme.fontSizeLineHeightMap]};`
      : ''}
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;

  ${lineClamp}
`;
